import { AppRole } from '@craft/database';

/**
 * The application roles permitted to view an embedded ThoughtSpot dashboard. Pages gate access
 * against this list before rendering the embed, and {@link createRuntimeFilters} derives the
 * role-appropriate display scoping from it.
 */
export const AllowedThoughtspotDashboardRoles = [
  AppRole.ADMIN,
  AppRole.OBSERVER,
  AppRole.INSTRUCTOR,
  AppRole.LEARNER,
  AppRole.EVALUATOR,
] as const;

export type AllowedThoughtspotDashboardRole = (typeof AllowedThoughtspotDashboardRoles)[number];
